import { render, staticRenderFns } from "./SpotlightGuide.vue?vue&type=template&id=63a9b252&scoped=true&"
import script from "./SpotlightGuide.vue?vue&type=script&lang=js&"
export * from "./SpotlightGuide.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightGuide.vue?vue&type=style&index=0&id=63a9b252&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a9b252",
  null
  
)

export default component.exports